import { render, staticRenderFns } from "./TagTab.vue?vue&type=template&id=4a9e07f8&scoped=true&"
import script from "./TagTab.vue?vue&type=script&lang=ts&"
export * from "./TagTab.vue?vue&type=script&lang=ts&"
import style0 from "./TagTab.vue?vue&type=style&index=0&id=4a9e07f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9e07f8",
  null
  
)

export default component.exports